<template>
  <div id="app">
    <!-- 添加该字段，表示不需要home模板 -->
    <transition v-if="!$route.meta.NoNeedHome" name="fade" mode="out-in">
      <el-row class="container_app">
        <div class="main_self">
          <!-- 左侧 -->
          <aside class="menu-expanded">
            <el-scrollbar style="height: 100%" class="scrollbar-handle">
              <img class="logo" src="./assets/moguLogo.png" alt="" />
              <el-menu
                :default-active="$route.path"
                unique-opened
                router
                :collapse="false"
                text-color="#ffffff"
                active-text-color="#003CCC"
                background-color="rgba(0,0,0,0)"
              >
                <sidebar
                  v-for="(menu, index) in routes"
                  :key="index"
                  :item="menu"
                  :id="menu.Description"
                />
              </el-menu>
            </el-scrollbar>
          </aside>
          <!-- 右侧 -->
          <div class="content-wrapper">
            <!-- 头部 -->
            <div class="header_self">
              <div class="tui-headerTitle">
                {{ userInfo.SchoolName }}智慧园所物联网大数据平台
              </div>
              <el-dropdown trigger="hover">
                <div class="right_menu">
                  <img class="userNameIcon" src="./assets/user.png" alt="" />
                  <div class="userName">{{ sysUserName }}</div>
                  <img class="downBotton" src="./assets/sanjiao.png" alt="" />
                </div>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="logout"
                    >退出登录</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            <div
              class="MateTitle"
              v-if="
                $route.meta.title != '我的工具' &&
                $route.meta.title != '资源管理' &&
                $route.meta.title != '蘑菇云盘' &&
                $route.meta.title != '云文档详情' &&
                $route.meta.title != '场馆列表' &&
                $route.meta.title != '场馆详情'
              "
            >
              {{ $route.meta.title }}
            </div>
            <div class="content_Body" :style="{ height: 'calc(100% - 85px)' }">
              <router-view></router-view>
            </div>
          </div>
        </div>
      </el-row>
    </transition>

    <transition v-else name="fade" mode="out-in">
      <div class="container_app">
        <router-view></router-view>
      </div>
    </transition>
  </div>
</template>
<script>
import Sidebar from "./components/Sidebar"; //根据动态路由 对el-submenu 的一层封装
import ScrollPane from "./components/ScrollPane";
import { getUserByToken } from "./api/api";

export default {
  components: { Sidebar, ScrollPane },
  data() {
    return {
      collapsed: false, //折叠菜单栏的标识
      sysUserName: "", //用户名
      tagsList: [], //tar标签列表
      routes: [], //左侧导航栏路由列表
      userInfo: {},
    };
  },
  methods: {
    //退出登录
    logout: function () {
      var _this = this;
      this.$confirm("确认退出吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          window.localStorage.removeItem("user");
          window.localStorage.removeItem("Token");
          window.localStorage.removeItem("TokenExpire");
          window.localStorage.removeItem("NavigationBar");
          window.localStorage.removeItem("refreshtime");
          window.localStorage.removeItem("router");
          sessionStorage.removeItem("Tags");
          this.tagsList = [];
          this.routes = [];
          this.$store.commit("saveTagsData", "");
          var loginurl = "/login";
          if (
            window.localStorage.loginurl != null &&
            window.localStorage.loginurl != ""
          )
            loginurl = window.localStorage.loginurl;
          _this.$router.replace(loginurl);
        })
        .catch(() => {});
    },

    // 标签卡的活动状态
    isActive(path) {
      return path === this.$route.fullPath;
    },
    // 关闭单个标签
    closeTags(index) {
      const delItem = this.tagsList.splice(index, 1)[0];
      const item = this.tagsList[index]
        ? this.tagsList[index]
        : this.tagsList[index - 1];
      if (item) {
        delItem.path === this.$route.fullPath && this.$router.push(item.path);

        this.$store.commit("saveTagsData", JSON.stringify(this.tagsList));
      } else {
        this.$router.push("/");
      }
    },
    // 关闭全部标签
    closeAll() {
      this.tagsList = [];
      this.$router.push("/");
      sessionStorage.removeItem("Tags");
    },
    // 关闭其他标签
    closeOther() {
      const curItem = this.tagsList.filter((item) => {
        return item.path === this.$route.fullPath;
      });
      this.tagsList = curItem;

      sessionStorage.setItem("Tags", JSON.stringify(this.tagsList));
    },
    // 设置标签
    setTags(route) {
      if (!route.meta.NoTabPage) {
        const isExist = this.tagsList.some((item) => {
          return item.path === route.fullPath;
        });
        !isExist &&
          this.tagsList.push({
            title: route.meta.title,
            path: route.fullPath,
          });
      }
    },
    // 当关闭所有页面时隐藏
    handleTags(command) {
      command === "other" ? this.closeOther() : this.closeAll();
    },
  },
  mounted() {
    var tags = sessionStorage.getItem("Tags")
      ? JSON.parse(sessionStorage.getItem("Tags"))
      : [];

    if (tags && tags.length > 0) {
      this.tagsList = tags;
    }

    var NavigationBar = JSON.parse(
      window.localStorage.router ? window.localStorage.router : null
    );
    if (this.routes.length <= 0 && NavigationBar && NavigationBar.length >= 0) {
      this.routes = NavigationBar;
    }
    // 折叠菜单栏
  },
  updated() {
    var user = JSON.parse(
      window.localStorage.user ? window.localStorage.user : null
    );
    if (user) {
      this.sysUserName = user.uRealName || "蘑菇岛用户";
    }
    var NavigationBar = JSON.parse(
      window.localStorage.router ? window.localStorage.router : null
    );

    if (NavigationBar && NavigationBar.length >= 0) {
      if (
        this.routes.length <= 0 ||
        JSON.stringify(this.routes) != JSON.stringify(NavigationBar)
      ) {
        this.routes = NavigationBar;
      }
    }
  },
  computed: {
    showTags() {
      if (this.tagsList.length > 1) {
        this.$store.commit("saveTagsData", JSON.stringify(this.tagsList));
      }
      return this.tagsList.length > 0;
    },
  },
  watch: {
    // 对router进行监听，每当访问router时，对tags的进行修改
    $route: async function (newValue, from) {
      this.setTags(newValue);
      const tags = this.$refs.tag;
      this.$nextTick(() => {
        if (tags) {
          for (const tag of tags) {
            if (tag.to.path === this.$route.path) {
              this.$refs.scrollPane.moveToTarget(tag, tags);
              break;
            }
          }
        }
      });
    },
  },
  created() {
    if (window.localStorage.user) {
      this.userInfo = JSON.parse(window.localStorage.user);
    }
    // 第一次进入页面时，修改tag的值
    this.setTags(this.$route);
  },
};
</script>
<style lang="less">
// /deep/.el-dialog {
//   border-radius: 10px;
//   overflow: hidden;
// }
// /deep/.el-dialog__header {
//   background: #f2f5ff;
// }
.el-dialog__header {
  background-color: #f2f5ff;

  .el-dialog__title,
  .el-dialog__headerbtn i {
    color: #333333;
  }
}

html {
  width: 100%;
}

body {
  width: 100%;
  height: 100vh;
}

* {
  padding: 0;
  margin: 0;
}

a {
  text-decoration: none;
}

#app,
.container_app {
  height: 100%;
  width: 100%;
}

// 头部样式
.header_self {
  position: relative;
  display: flex;
  justify-content: space-between;
  height: 86px;
  background: #ffffff;
  align-items: center;
  box-sizing: border-box;
  padding: 0 47px;
}

.tui-headerTitle {
  font-size: 24px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #333333;
}

.right_menu {
  display: flex;
  align-items: center;

  .userName {
    font-size: 14px;
    font-weight: 600;
    color: #333333;
    line-height: 30px;
    padding-right: 10px;
  }

  .userNameIcon {
    width: 40px;
    height: 40px;
    object-fit: contain;
    border-radius: 50%;
    margin-right: 10px;
  }

  .downBotton {
    width: 10px;
    object-fit: contain;
    height: auto;

    // transform: rotate(180deg) translateX(-10px);
  }
}

// 主体
.main_self {
  display: flex;
  height: 100%;
  overflow: hidden;
  justify-content: flex-start;
  background-color: #f3f3f3;
}

// 左侧菜单栏
.menu-expanded {
  width: 250px !important;
  box-sizing: border-box;
  height: 100%;
  box-sizing: border-box;
  padding-top: 23px;
  background: linear-gradient(115deg, #849fff 0%, #5d99ff 100%);

  .logo {
    width: 104px;
    height: auto;
    display: block;
    margin-left: 47px;
    margin-bottom: 30px;
  }

  .el-menu {
    border-right: none;
  }

  //设置鼠标悬停时el-menu-item的样式
  .fa {
    margin-right: 10px;
  }

  //设置选中el-menu-item时的样式
  .el-menu-item.is-active {
    background-color: #5474e6 !important;
    color: #fff !important;
    border-left: none !important;
  }

  .el-menu-item {
    font-size: 0.2rem;
  }

  //设置鼠标悬停时el-submenu的样式
  .el-submenu .el-submenu__title:hover {
    background-color: #5474e6 !important;
  }

  .el-submenu .el-menu-item:hover {
    background-color: #5474e6 !important;
  }

  .el-menu-item:hover {
    background-color: #5474e6 !important;
  }

  .el-menu-item.is-active i {
    color: #003ccc !important;
  }

  .el-submenu .el-submenu__title {
    font-size: 0.2rem;

    i {
      color: #fff !important;
    }
  }

  .el-menu-item i {
    color: #fff !important;
  }
}

// 右侧内容区域
.content-wrapper {
  margin: 0px;
  padding: 0px;
  width: calc(100% - 250px);
}

// 标签卡
.MateTitle {
  height: 45px;
  line-height: 45px;
  margin-left: 20px;
  font-size: 0.225rem;
  font-weight: 600;
  color: #333333;
}

.tags {
  background-color: #fff;
  display: flex;
  height: 50px;
  align-items: center;
  padding: 0 20px;
  margin-bottom: 10px;
}

.tags-view-container {
  padding-right: 20px;
  width: calc(100% - 60px);
}

.tags-view-container .tags-view-wrapper .tags-view-item {
  display: inline-block;
  position: relative;
  cursor: pointer;
  height: 26px;
  line-height: 26px;
  border: 1px solid #d8dce5;
  color: #495060;
  background: #fff;
  padding: 0 8px;
  font-size: 12px;
  margin-right: 10px;
}

.tags-view-container .tags-view-wrapper .tags-view-item.active::before {
  content: "";
  background: #2d8cf0;
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  position: relative;
  margin-right: 2px;
}

.content_Body {
  // background-color: #fff;
  padding: 0 20px;
  box-sizing: border-box;
  // overflow: scroll;
}
</style>
